var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.277 9.6383L25.6285 6.95457C25.7704 6.51937 25.8472 6.0543 25.8472 5.57217C25.8472 3.10283 23.845 1.1007 21.3757 1.1007C20.0562 1.1007 18.8712 1.67243 18.053 2.58123L15.5496 1.1359C14.8061 0.706034 14.0093 0.553501 13.2498 0.623901C12.901 0.569501 12.5266 0.627101 12.181 0.826568L11.6914 1.10923C11.6584 1.12737 11.6253 1.14657 11.5922 1.16577L0.822088 7.38443C-0.273378 8.01697 -0.273378 9.59777 0.822088 10.2292L9.68715 15.3471V21.5274C9.68715 24.5364 12.9437 26.417 15.5496 24.9119L30.2781 16.4084C32.884 14.9044 32.884 11.1434 30.2781 9.63937L30.277 9.6383Z",
    fill: "#FC6264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4253 9.27841C23.3729 9.27841 24.9517 7.69434 24.9517 5.74028C24.9517 3.78622 23.3729 2.20215 21.4253 2.20215C19.4778 2.20215 17.8989 3.78622 17.8989 5.74028C17.8989 7.69434 19.4778 9.27841 21.4253 9.27841Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4776 7.18861C23.4513 7.18861 24.2408 6.39634 24.2408 5.41901C24.2408 4.44169 23.4513 3.64941 22.4776 3.64941C21.5038 3.64941 20.7144 4.44169 20.7144 5.41901C20.7144 6.39634 21.5038 7.18861 22.4776 7.18861Z",
    fill: "#1A191F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.426 5.05467C21.9126 5.05467 22.3071 4.65877 22.3071 4.1704C22.3071 3.68203 21.9126 3.28613 21.426 3.28613C20.9394 3.28613 20.5449 3.68203 20.5449 4.1704C20.5449 4.65877 20.9394 5.05467 21.426 5.05467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f5f0c333f5a09c0628f17b805575324e.svg";
export { ForwardRef as ReactComponent };